import React, { useEffect } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { Row, Container, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./AddPoints.module.scss";
import { useDispatch, useSelector } from "react-redux";
import successMessage from "../../messages/Successful";
import failedMessage from "../../messages/Failed";
import { addPoints } from "../../../redux/features/cashierSlice";
import { toast, Zoom } from "react-toastify";
import { compare, decrypt } from "n-krypta";
import ChangeLang from "../../changeLang/ChangeLang";
import { useTranslation } from "react-i18next";

export default function AddPoints() {
  const navigate = useNavigate();

  const addPointsValidation = yup.object().shape({
    customerMobile: yup
      .string()
      .required("customerMobileReq")
      .matches(/^01[0125][0-9]{8}$/gm, "customerMobileNotValid"),
    receiptValue: yup.number().required("receiptValueReq"),
    orderNumber: yup.string().required("orderNumberReq"),
  });

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const key = "ShareeCoin_1234567";
  const merchantNamee = useParams().merchant;
  const storedMerchant = useSelector(
    (state) => state.green.cashier.login.merchantName
  );

  useEffect(() => {
    if (compare(merchantNamee, storedMerchant, key) === false) {
      navigate(`/${decrypt(storedMerchant, key)}/cashier/login`);
    }
  }, [storedMerchant]);

  const token = useSelector((state) => state.green.cashier.login.token);

  const handleMerchant = (name) => {
    const capitalLetter = name.replace(/[^A-Z]/g, "");
    const capitalPostion = name.search(capitalLetter);
    const partTwo = name.slice(capitalPostion);
    const partOne = name.substring(capitalPostion, -1);
    const final = partOne.charAt(0).toUpperCase() + partOne.slice(1);
    return `${final} ${partTwo}`;
  };

  return (
    <div className={`${styles.addPointsContent} p-3 p-md-5`}>
      <Container>
        <Row>
          <Col xs={12} className="mb-3">
            <ChangeLang />
          </Col>
          <Col xs={12}>
            <h4 className={`${styles.addPointsTitle} px-4`}>
              {t("addPoints")}
            </h4>
          </Col>
        </Row>
      </Container>
      <Formik
        initialValues={{
          customerMobile: "",
          receiptValue: "",
          orderNumber: "",
        }}
        onSubmit={(values, actions) => {
          const loadReq = toast.loading(t("loading"), {
            transition: Zoom,
            position: i18n.language === "ar" ? "bottom-right" : "bottom-left",
          });
          setTimeout(() => {
            actions.setSubmitting(false);
          }, 3000);
          dispatch(
            addPoints({
              merchantName: handleMerchant(decrypt(storedMerchant, key)).trim(),
              receiptValue: values.receiptValue,
              orderNumber: values.orderNumber,
              customerMobile: values.customerMobile,
              token,
            })
          ).then((res) => {
            if (res.payload.data.statusCode === 200) {
              successMessage(
                res.payload.data.message,
                res.payload.data["messageAr"],
                loadReq
              );
              navigate(`/${decrypt(storedMerchant, key)}/cashier/dashboard`);
            } else {
              failedMessage(
                res.payload.data.error,
                res.payload.data["errorAr"],
                loadReq
              );
            }
          });
        }}
        validationSchema={addPointsValidation}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <Col sm={12} className={`${styles.bgWhite} p-4 mb-3`}>
                    <h4>{t("customerData")}</h4>
                    <Container>
                      <Row>
                        <Col xs={12} sm={6}>
                          <Form.Group as={Row}>
                            <Form.Label
                              column
                              sm={12}
                              className={`${styles.addPointsLabel}`}
                            >
                              {t("customerMobile")}
                            </Form.Label>
                            <Col
                              sm={8}
                              className={`${styles.bgGrey} px-3 py-2`}
                            >
                              <Form.Control
                                type="tel"
                                maxLength={11}
                                className={`${styles.addpointInput}`}
                                id="customerMobile"
                                name="customerMobile"
                                onKeyPress={(e) => {
                                  var char = String.fromCharCode(e.which);
                                  if (!/[0-9]/.test(char)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={handleChange}
                                value={values.customerMobile}
                              />
                            </Col>
                            {errors.customerMobile &&
                              touched.customerMobile && (
                                <Form.Text className="text-error-green">
                                  {t(errors.customerMobile)}
                                </Form.Text>
                              )}
                          </Form.Group>
                        </Col>
                        <Col xs={12} sm={6}>
                          <Form.Group as={Row}>
                            <Form.Label
                              column
                              sm={12}
                              className={`${styles.addPointsLabel}`}
                            >
                              {t("receiptValue")}
                            </Form.Label>
                            <Col
                              sm={8}
                              className={`${styles.bgGrey} px-3 py-2`}
                            >
                              <Form.Control
                                type="number"
                                id="receiptValue"
                                className={`${styles.addpointInput}`}
                                name="receiptValue"
                                onKeyPress={(e) => {
                                  var char = String.fromCharCode(e.which);
                                  if (!/[0-9]/.test(char)) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={handleChange}
                                value={values.receiptValue}
                              />
                            </Col>

                            <Col xs={3}>
                              <Form.Text
                                className={`${styles.receiptValueUnit}`}
                              >
                                {t("egp")}
                              </Form.Text>
                            </Col>
                            {errors.receiptValue && touched.receiptValue && (
                              <Form.Text className="text-error-green">
                                {t(errors.receiptValue)}
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                  <Col xs={12} md={8} className={`${styles.bgWhite} p-4 mb-3`}>
                    <h4>{t("orderNumber")}</h4>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <Form.Group as={Row}>
                            <Form.Label
                              column
                              sm={12}
                              className={`${styles.addPointsLabel} mb-3`}
                            >
                              {t("completeTrans")}
                            </Form.Label>
                            <Col
                              xs={12}
                              md={6}
                              className={`${styles.bgGrey} px-3 py-2`}
                            >
                              <Form.Control
                                type="text"
                                maxLength={20}
                                id="orderNumber"
                                className={`${styles.addpointInput}`}
                                name="orderNumber"
                                onChange={handleChange}
                                value={values.orderNumber}
                              />
                            </Col>
                            {errors.orderNumber && touched.orderNumber && (
                              <Form.Text className="text-error-green">
                                {t(errors.orderNumber)}
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                  <Col xs={12} md={4}>
                    <div
                      className={`${styles.addpointsBtnContent} d-flex align-items-start align-items-md-end`}
                    >
                      <Button
                        type="submit"
                        variant="danger"
                        size="lg"
                        className={`${styles.addPointsBtn} w-100`}
                        disabled={isSubmitting}
                      >
                        {t("addBtn")}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
